<template>
    <transition
        appear
        :css="false"
        @enter="zoomIn"
    >
        <div
            class="thought-bubble"
            :class="direction"
        >
            <div ref="bubble1" class="bubble-1" />
            <div ref="bubble2" class="bubble-2" />
            <div ref="content" class="bubble-content">
                <slot />
            </div>
        </div>
    </transition>
</template>

<script>
import gsap from 'gsap';

export default {
    name: 'ThoughtBubble',
    props: {
        direction: {
            type: String,
            default: ''
        }
    },
    methods: {
        zoomIn()
        {
            const {$refs} = this;
            this.$audioController.play('thought-bubble');
            gsap.timeline()
                .fromTo(
                    $refs.bubble1,
                    {scale: 0.5, opacity: 0},
                    {
                        duration: 0.6,
                        scale: 1,
                        opacity: 1,
                        ease: 'elastic.out(1.1, 0.8)',
                        force3D: false
                    }
                )
                .fromTo(
                    $refs.bubble2,
                    {scale: 0.5, opacity: 0},
                    {duration: 0.6, scale: 1, opacity: 1, ease: 'elastic.out(1.1, 0.8)'},
                    0.3
                )
                .fromTo(
                    $refs.content,
                    {scale: 0.5, opacity: 0},
                    {duration: 0.6, scale: 1, opacity: 1, ease: 'elastic.out(1.1, 0.9)'},
                    0.6
                );
        }
    }
};
</script>

<style lang="scss" src="./ThoughtBubble.scss" />

